<template>
    <b-input-group>
        <b-form-input :id="id"
                      :name="name"
                      :type="hidden ? 'password' : 'text'"
                      v-model="content"
                      :state="state"
                      @update="onUpdate">
        </b-form-input>
        <template #append>
            <b-input-group-text @click="hidden=!hidden"><i :class="{ 'fas': true, 'fa-eye': hidden, 'fa-eye-slash': !hidden }"></i></b-input-group-text>
        </template>
    </b-input-group>
</template>

<script>    
    import Vue from 'vue';
    import BootstrapVue from 'bootstrap-vue';
    Vue.use(BootstrapVue);
    export default {
        name: 'SensitiveInput',
        props: {
            id: {
                type: String,
                default: 'sensitive-input'
            },
            name: {
                type: String,
                default: 'sensitive-input'
            },
            value: {
                type: String,
                default: null
            },
            initialHidden: {
                type: Boolean,
                default: true
            },
            state: {
                type: Boolean,
                default: null
            }
        },
        model: {
            event: 'update',
            prop: 'value'
        },
        data() {
            return {
                content: this.value,
                hidden: this.initialHidden
            }
        },
        methods: {
            onUpdate() {
                this.$emit('update', this.content);
            }
        }
    }
</script>